import { render } from "./Form.vue?vue&type=template&id=1a16f6be"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
script.render = render

export default script